/**
 * Sorts an array by multiple criteria
 */
export const sortBy = <T>(array: T[], ...selectors: ((item: T) => unknown)[]): T[] => {
  return [...array].sort((a, b) => {
    for (const selector of selectors) {
      const aVal = selector(a) as number | string | boolean | undefined | null
      const bVal = selector(b) as number | string | boolean | undefined | null
      if (aVal! < bVal!) return -1
      if (aVal! > bVal!) return 1
    }
    return 0
  })
}
